(function () {
  'use strict';

  angular
    .module('component.delete-cart-item', [])

    .component('buttonDeleteCartItem', {
      bindings: {
        idLine: '<',
        btnClass: '@',
        designation: '@productDesignation',
        img: '<productImg',
        titleBtn: '@?',
        titleDeleteOk: '@?'
      },
      templateUrl: 'component.delete-cart-item.tpl',
      /* @ngInject */
      controller: ["LoadService", function (LoadService) {
        var ctrl = this;

        ctrl.$onInit = function () {
          ctrl.js = $(document.body).data('js-components');
          LoadService.getService('AsyncComponentsService', { ctrl: ctrl }, 'initDelete');
        };
      }]
    });

})();
